import { useEffect, useState } from 'react'
import { styled } from '@linaria/react'

import goUp from '../../assets/common/go_up.svg'

const Container = styled.button`
  cursor: pointer;
  display: flex;
  margin-bottom: 5px;
  animation: fadeIn 0.2s ease-in-out;
  * {
    pointer-events: none;
  }
  &:hover {
    transform: scale(1.05);
  }
`

const GoUp = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > 200)
    }

    window.addEventListener('scroll', onScroll)
    return () => window.addEventListener('scroll', onScroll)
  }, [])

  if (!isVisible) return null

  return (
    <Container id="go-up" aria-label="scroll up">
      <img src={goUp} style={{ width: 50, height: 51.66 }} alt="scroll up" />
    </Container>
  )
}

export default GoUp
